import { useState, useEffect, useRef } from 'react'
import Swal from 'sweetalert2'
import Breadcrumb from '../../../components/breadcrumb/index'
export default function MailSetting() {
    const title = "One Signal Setting"
    const brad = [
        {
            name: "home",
        },
        {
            name: title,
        }
    ]
    const [rerendarApi, setRerendarApi] = useState(false)
    
    {/* data receve from store */ }
    useEffect(() => {
        
    //    call api
        console.log("RENDER FROM STORE TRASH")
    }, [rerendarApi])


    const updateOnSignal = () => {

        Swal.fire({
            icon: 'info',
            title: 'Are You Want to take this action',
            showCancelButton: true,
            confirmButtonText: 'Yes',
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                setRerendarApi(!rerendarApi)
               
                Swal.fire('Updated!', '', 'success')
            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        })
    }
    return (
        <>

            <div  className="container-fluid">
                <Breadcrumb title={title} brad={brad} />

                <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
                    <div className="card-header d-flex justify-content-between border-bottom pb-1">
                        <div className="">{title} </div>
                        
                    </div>
                    <div className="card-body">
                        <div  className="row ">
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>Enable OneSignal</ b></label>
                                <select className="form-control">
                                    <option value="on">On</option>
                                    <option value="off">Off</option>

                                </select>
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>oneSignal Api Id</ b></label>
                                <input type="text" placeholder="Enter Onedignal Api Id" className="form-control" />
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>oneSignal Api Key</ b></label>
                                <input type="text" placeholder="Enter Onedignal Api Key" className="form-control" />
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>Complete Payment Notification to Admin</ b></label>
                                <select className="form-control">
                                    <option value="">On</option>
                                    <option value="">Off</option>

                                </select>
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>Pending Payment Notification to Admin</ b></label>
                                <select className="form-control">
                                    <option value="">On</option>
                                    <option value="">Off</option>

                                </select>
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>Transaction Not Found Notification to Admin</ b></label>
                                <select className="form-control">
                                    <option value="">On</option>
                                    <option value="">Off</option>

                                </select>
                            </div>

                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>Smtp Require Authentication?</ b></label>
                                <select className="form-control">
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>

                                </select>
                            </div>
                            
                            
                        </div>
                        <button onClick={updateOnSignal} className="btn btn-primary btn-sm mt-3">Update</button>
                    </div>
                </div>
            </div>

        </>
    )
}